
// frontend/src/pages/LandingPage/LandingPage.jsx (Versão 1.0.0 - Implementação Futurista)
import React from 'react';
import HeaderPublic from '../../components/Navigation/HeaderPublic'; 
import HeroSection from '../../components/LandingPage/HeroSection';
import FeaturesSection from '../../components/LandingPage/FeaturesSection';
import DemoSection from '../../components/LandingPage/DemoSection';
import StatsSection from '../../components/LandingPage/StatsSection';
import IntegrationsSection from '../../components/LandingPage/IntegrationsSection';
import FinalCTASection from '../../components/LandingPage/FinalCTASection';
import Footer from '../../components/LandingPage/Footer';

const LandingPage = () => {
    return (
        // Fundo principal da página é branco
        <div className="min-h-screen bg-gray-50"> 
            
            {/* 🎯 Container Flutuante para Header e Hero */}
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-8 lg:pt-12"> 
                <div className="bg-white rounded-3xl overflow-hidden shadow-2xl ring-1 ring-gray-100">
                    
                    {/* Header Público */}
                    <HeaderPublic /> 
                    
                    {/* Seção Hero */}
                    <HeroSection />
                </div>
            </div>
            
            <main>
                {/* Seção de Recursos */}
                <FeaturesSection />
                
                {/* Seção de Demonstração Visual */}
                <DemoSection />
                
                {/* Seção de Estatísticas */}
                <StatsSection />
                
                {/* Seção de Integrações e Tecnologia */}
                <IntegrationsSection />
                
                {/* CTA Final */}
                <FinalCTASection />
            </main>
            
            {/* Footer */}
            <Footer />
        </div>
    );
};

export default LandingPage;